import React, { useEffect, useState } from 'react'
import { IconButton, Typography, Grid, Paper, Button } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LambdaFetch from '../functions/FetchFromLambda'
import { makeStyles } from '@material-ui/core/styles'
import SimpleAutoComplete from '../functions/SimpleAutoComplete'
import LoadingCircle from '../components/common/LoadingCircle'
import LoadingButton from '../components/LoadingButton'
import ItemDetail from '../components/ItemDetail'
import { smallScreenWidth } from '../constants/AppConstants'
import ServerSideAutoCompletev2 from '../functions/ServerSideAutoCompletev2'
import AutocompleteDropDown from '../components/AutocompleteDropdown'
import fetchFromAthena from '../functions/FetchFromAthena'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '1rem 1rem 0 1rem'
  }
}))

export default function Item (props) {
  const classes = useStyles()
  const { credentials } = props.fetchInitialData
  const [state, setstate] = useState({
    itemData: null,
    gtinData: null,
    groups: [],
    fetched: false,
    isFetching: false
  })
  const [headers, setHeaders] = React.useState({
    itemGroup: null,
    item: null
  })
  const [clearHeader, setClearHeaders] = React.useState(false)

  useEffect(() => {
    async function fetch () {
      try {
        const resp = await LambdaFetch(
          'item',
          'post',
          credentials.user.accessToken,
          JSON.stringify({
            action: 'get-groups'
          }),
          '',
          credentials
        )
        setstate({ ...state, groups: resp.data.groups, fetched: true })
      } catch (e) {
        console.log(e)
      }
    }
    fetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getItem = async e => {
    e.preventDefault()
    try {
      setstate({ ...state, isFetching: true })

      const queries = ['item_read']

        const data = await Promise.allSettled(
            queries.map(query =>
                fetchFromAthena({
                    queryName: query,
                    headers,
                    accessToken: credentials.user.accessToken,
                    credentials: credentials
                })
            )
        ).then(results => {
            return results
        })

      setstate({
        ...state,
        itemData: data[0].value[0],
        isFetching: false
      })

      // const resp = await LambdaFetch(
      //   'item',
      //   'post',
      //   credentials.user.accessToken,
      //   JSON.stringify({  
      //     action: 'get-item',
      //     itemGroup: headers.itemGroup,
      //     item: headers.item
      //   }),
      //   '',
      //   credentials
      // )

      // setstate({
      //   ...state,
      //   itemData: resp.data.item[0],
      //   isFetching: false
      // })
    } catch (e) {
      console.log(e)
    }
  }

  const handleChange = (name, value) => {
    setHeaders({ ...headers, [name]: value })
  }

  const { itemData,gtinData } = state

  if (!state.fetched) {
    return <LoadingCircle />
  }
  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Item (IC11)
      </Typography>

      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={getItem}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              <Grid item>
              <AutocompleteDropDown
                  {...props}
                  id={'itemGroup'}
                  name={'itemGroup'}
                  width='200px'
                  key={clearHeader}
                  required={true}
                  variant='standard'
                  label={'Item Group'}
                  value={headers.itemGroup}
                  category={'item-group'}
                  screen={'item'}
                  onChange={val => handleChange('itemGroup', val ? val.key_value : null)}
                />
              </Grid>
              <Grid item>
                <ServerSideAutoCompletev2
                  disabled={false}
                  id='item'
                  width='320px'
                  required={true}
                  label='Item'
                  key={clearHeader}
                  accessToken={credentials.user.accessToken}
                  error='No Item found'
                  variant='standard'
                  handleChange={(id, hit) => {
                    handleChange('item', id)
                  }}
                  credentials={credentials}
                  apiResource='item'
                  secondaryParams={{
                    limit: 25,
                    itemGroup: headers.itemGroup,
                    action: 'item-autocomplete'
                  }}
                />
              </Grid>
            </Grid>
            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                isLoading={state.isFetching}
                color='primaryVLButton'
                buttonType='submit'
              />
              {!!(
                headers.itemGroup ||
                headers.item
              ) && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader)
                    setHeaders({
                      itemGroup: null,
                      item: null
                    })
                    setstate({
                      ...state,
                      itemData: null
                    })
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>

        {itemData && (
          <Grid
            item
            xs={12}
            style={{ position: 'relative', marginTop: '1rem' }}
          >
            <ItemDetail {...props} itemData={itemData} gtinData={gtinData}/>
          </Grid>
        )}
      </div>
    </div>
  )
}
